import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useWindowSize } from 'react-use';
import useIsBrowser from 'hooks/useIsBrowser';
const useScreen = () => {
  const $ = _c(15);
  const isBrowser = useIsBrowser();
  const returnDefaults = !isBrowser;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      query: "(max-width: 767px)"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isMobile = useMediaQuery(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      query: "(max-width: 1023px)"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isMobileOrTablet = useMediaQuery(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      query: "(min-width: 768px)"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isTabletOrDesktop = useMediaQuery(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      query: "(min-width: 1024px)"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const isDesktop = useMediaQuery(t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      query: "(min-width: 1440px)"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const isUltraWide = useMediaQuery(t4);
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      query: "(min-width: 1800px)"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const isExtraWide = useMediaQuery(t5);
  const {
    width: windowWidth
  } = useWindowSize();
  let t6;
  bb0: {
    if (returnDefaults) {
      let t7;
      if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
          isMobile: true,
          isMobileOrTablet: true,
          isTabletOrDesktop: false,
          isDesktop: false,
          isUltraWide: false,
          isExtraWide: false,
          windowWidth: 390
        };
        $[6] = t7;
      } else {
        t7 = $[6];
      }
      t6 = t7;
      break bb0;
    }
    let t7;
    if ($[7] !== isDesktop || $[8] !== isExtraWide || $[9] !== isMobile || $[10] !== isMobileOrTablet || $[11] !== isTabletOrDesktop || $[12] !== isUltraWide || $[13] !== windowWidth) {
      t7 = {
        isMobile,
        isMobileOrTablet,
        isTabletOrDesktop,
        isDesktop,
        isUltraWide,
        isExtraWide,
        windowWidth
      };
      $[7] = isDesktop;
      $[8] = isExtraWide;
      $[9] = isMobile;
      $[10] = isMobileOrTablet;
      $[11] = isTabletOrDesktop;
      $[12] = isUltraWide;
      $[13] = windowWidth;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    t6 = t7;
  }
  return t6;
};
export default useScreen;